const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'andromeda',
            client_id: '07-tendermint-9',
            connection_id: 'connection-9'
        },
        chain_2: {
            chain_name: 'archway',
            client_id: '07-tendermint-58',
            connection_id: 'connection-68'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-11',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-97',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'andromeda',
            client_id: '07-tendermint-16',
            connection_id: 'connection-12'
        },
        chain_2: {
            chain_name: 'injective',
            client_id: '07-tendermint-250',
            connection_id: 'connection-244'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-13',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-213',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'andromeda',
            client_id: '07-tendermint-6',
            connection_id: 'connection-4'
        },
        chain_2: {
            chain_name: 'kujira',
            client_id: '07-tendermint-164',
            connection_id: 'connection-127'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-5',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-123',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'andromeda',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        chain_2: {
            chain_name: 'secretnetwork',
            client_id: '07-tendermint-176',
            connection_id: 'connection-133'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-97',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'andromeda',
            client_id: '07-tendermint-15',
            connection_id: 'connection-11'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-409',
            connection_id: 'connection-413'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-12',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-351',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
